import axios from "axios";
import { API_HOST } from "@/core/variables";
import { MessageHistorySearchType } from "@/model";
import { getUtcZeroTime } from "@/util/dateUtil";


class ConversationRepository {
    find = async (
        scenarioId: string,
        startDate: string,
        endDate: string,
        searchType: MessageHistorySearchType,
        searchKeyword?: string,
        page?: number,
        size?: number
    ) => {
        const params: any = {
            page: page,
            size: size,
            start_date: getUtcZeroTime(startDate, "YYYY-MM-DD HH:mm:ss"),
            end_date: getUtcZeroTime(endDate, "YYYY-MM-DD HH:mm:ss")
        };

        if (searchKeyword) {
            if (searchType === "user_query") {
                params.sender_type = "user";
                params.condition = searchKeyword;
            } else if (searchType === "bot_query") {
                params.sender_type = "bot";
                params.condition = searchKeyword;
            } else if (searchType === "user_key") {
                params.search_factors = `{"context.system.global.user_key":"${searchKeyword}"}`;
            } else if (searchType === "conversation_id") {
                params.search_factors = `{"conversation_id":"${searchKeyword}"}`;
            }
        }

        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/conversations`, {
                params: params
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    findMessages = async (
        scenarioId: string, 
        conversationId: string, 
        page?: number, 
        size?: number, 
        sort?: string
    ) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/conversations/${conversationId}/messages`, {
                params: {
                    page: page,
                    size: size,
                    sort: sort
                }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    searchMessages = async (
        scenarioId: string, 
        conversationId: string, 
        senderType?: string, 
        condition?: string
    ) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/conversations/${conversationId}/searchmessages`, {
                params: {
                    sender_type: senderType,
                    condition: condition
                }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    findPaginatedMessagesWithPosition = async (
        scenarioId: string,
        conversationId: string,
        senderType?: string,
        condition?: string,
        position?: number,
        size?: number
    ) => {
        return axios
        .get(`${API_HOST}/scenario/${scenarioId}/conversations/${conversationId}/messagesbyposition`,{
            params: {
                sender_type: senderType,
                condition: condition,
                position: position || 0,
                size: size
            }
        })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error));
    };
}

const conversationRepository = new ConversationRepository();

export default conversationRepository; 
